import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { tokenStore } from '@/lib/api/tokenStore'

import { resolvePostLoginPath } from './postLogin'

/**
 * 이미 로그인했으면 로그인 화면을 보여주지 않는다.
 *
 * 목적지 계산은 `resolvePostLoginPath()` **한 곳**이 소유한다(설계 D11) — 로그인 성공 직후,
 * `/` 진입, 여기 세 곳이 각자 계산하면 서로 어긋난다.
 */
export function GuestRoute({ children }: { children: ReactNode }) {
  const location = useLocation()

  if (tokenStore.hasValidSession()) {
    return <Navigate to={resolvePostLoginPath(location.search)} replace />
  }
  return <>{children}</>
}
